import React from 'react'
import { Row, Col, Card, Typography, Timeline } from 'antd'
import { AimOutlined, TrophyOutlined, HeartOutlined } from '@ant-design/icons'
import './About.css'

const { Title, Paragraph } = Typography

const About: React.FC = () => {
  const values = [
    {
      icon: <AimOutlined />,
      title: '使命',
      description: '传承千年中医药智慧，融合现代AI技术，推动中医药现代化发展',
    },
    {
      icon: <TrophyOutlined />,
      title: '愿景',
      description: '成为全球领先的中医药人工智能平台，让中医药智慧惠及更多人',
    },
    {
      icon: <HeartOutlined />,
      title: '价值观',
      description: '专业、创新、传承、融合，以科技赋能中医药，以智慧服务健康',
    },
  ]

  const milestones = [
    { year: '2020', event: '项目启动，团队组建' },
    { year: '2021', event: '核心AI技术研发完成' },
    { year: '2022', event: '知识库建设完成，平台上线' },
    { year: '2023', event: '用户突破10万，获得行业认可' },
    { year: '2024', event: '持续创新，推出多智能体诊疗系统' },
  ]

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="section-container">
          <Title level={1} className="page-title">关于我们</Title>
          <Paragraph className="page-subtitle">
            岐黄智医网络平台致力于将传统中医药与现代人工智能技术深度融合，
            构建一个集教育、诊疗、工具于一体的智能化平台
          </Paragraph>
        </div>
      </div>

      <div className="section-container">
        <Row gutter={[48, 48]}>
          <Col xs={24} lg={12}>
            <Title level={2}>平台简介</Title>
            <Paragraph>
              岐黄智医网络平台是一个基于多智能体协作框架的中医药人工智能平台。
              我们整合了经典文献、现代研究、诊疗经验等海量中医药知识，通过AI技术
              赋能中医药教育、诊疗和工具应用，推动中医药的传承与创新。
            </Paragraph>
            <Paragraph>
              平台采用前后端分离架构，基于三库（知识库、数据库、规则库）支撑，
              通过n8n工作流引擎实现多智能体协同工作，为中医药从业者和患者
              提供智能化、专业化的服务。
            </Paragraph>
          </Col>
          <Col xs={24} lg={12}>
            <Title level={2}>发展历程</Title>
            <Timeline
              items={milestones.map((item) => ({
                children: (
                  <div>
                    <div className="timeline-year">{item.year}</div>
                    <div className="timeline-event">{item.event}</div>
                  </div>
                ),
              }))}
            />
          </Col>
        </Row>
      </div>

      <div className="values-section">
        <div className="section-container">
          <Title level={2} className="section-title">我们的理念</Title>
          <Row gutter={[32, 32]}>
            {values.map((value, index) => (
              <Col xs={24} md={8} key={index}>
                <Card className="value-card" variant="borderless">
                  <div className="value-icon">{value.icon}</div>
                  <Title level={4} className="value-title">{value.title}</Title>
                  <Paragraph className="value-description">{value.description}</Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>

      <div className="section-container">
        <Title level={2} className="section-title">联系我们</Title>
        <Row gutter={[32, 32]}>
          <Col xs={24} md={8}>
            <Card className="contact-card">
              <Title level={4}>邮箱</Title>
              <Paragraph>info@qihuangai.com</Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="contact-card">
              <Title level={4}>电话</Title>
              <Paragraph>+86 123 4567 8901</Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card className="contact-card">
              <Title level={4}>地址</Title>
              <Paragraph>中国某市某区某街道123号</Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default About

